module.exports = __webpack_public_path__ + "static/media/delettable.15fcc175.svg";